import { tss } from 'tss-react/mui';

export const useControlBarStyles = tss.create(({ theme }) => ({
  container: {
    position: 'relative',
    height: '72px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 24px',
    backgroundColor: '#ffffff',
    borderTop: '1px solid #e5e7eb',
  },
  controlsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '16px',
  },
  micButton: {
    width: '42px',
    height: '42px',
    borderRadius: '50%',
    transition: 'all 0.15s ease',
    boxShadow: 'none',
    '& .MuiSvgIcon-root': {
      fontSize: '20px',
    },
    '&:hover': {
      boxShadow: 'none',
    },
  },
  micButtonActive: {
    backgroundColor: '#10b981',
    color: '#ffffff',
    '&:hover': {
      backgroundColor: '#059669',
    },
  },
  micButtonMuted: {
    backgroundColor: '#fef2f2',
    color: '#ef4444',
    border: '1.5px solid #fecaca',
    '&:hover': {
      backgroundColor: '#fee2e2',
    },
  },
  endCallButton: {
    padding: '8px 24px',
    borderRadius: '24px',
    fontSize: '14px',
    fontWeight: 600,
    textTransform: 'none' as const,
    minWidth: '130px',
    boxShadow: 'none',
    backgroundColor: '#ef4444',
    transition: 'all 0.15s ease',
    '& .MuiSvgIcon-root': {
      fontSize: '18px',
    },
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: '#dc2626',
    },
  },
  connectingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
  },
  loadingDot: {
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    animation: '$pulse 1.5s ease-in-out infinite',
  },
  connectingText: {
    color: '#6b7280',
    fontWeight: 500,
    fontSize: '14px',
  },
  '@keyframes pulse': {
    '0%, 100%': {
      opacity: 0.4,
      transform: 'scale(1)',
    },
    '50%': {
      opacity: 1,
      transform: 'scale(1.2)',
    },
  },
}));
